import { loadWebMapById } from "./arcgisMapUtils";

/** Expansion segment/subsegment network map (work_order attribute filter). */
export const EXPANSION_SEGMENT_WEBMAP_ID = "e2d41dce049d4cdea25d4d811ec12839";

/**
 * Editable CVIN MMBI Segments feature layer (portal item id).
 * Used for phase/subphase applyEdits; prefer over discovering layers from the web map.
 */
export const EXPANSION_SEGMENTS_FEATURE_LAYER_ITEM_ID = "b0ea24f9de364c59926509a09b3b5402";

/**
 * Titles to try when locating the segments feature layer, in priority order.
 * The web map stacks several copies of the same segments service under different
 * names/symbology (MAIN + themed overlays). Matching falls back to the
 * work_order field when titles change.
 */
export const EXPANSION_SEGMENTS_LAYER_TITLES = [
  "MAIN",
  "Status",
  "Contract",
  "Railroad",
  "Water",
  "CVIN MMBI Segments - Main",
  "CVIN MMBI Segments",
  "Segments",
];

/** Primary title; kept as a scalar for callers that only need a default. */
export const EXPANSION_SEGMENTS_LAYER_TITLE = EXPANSION_SEGMENTS_LAYER_TITLES[0];

/** @deprecated Use EXPANSION_SEGMENTS_LAYER_TITLE */
export const EXPANSION_PERMITS_OVERVIEW_LAYER_TITLE = EXPANSION_SEGMENTS_LAYER_TITLE;

export const EXPANSION_WORK_ORDER_FIELD = "work_order";

/** Substring identifying the segments feature service, used when titles don't match. */
export const EXPANSION_SEGMENTS_SERVICE_HINT = "CVIN_MMBI_Segments";

/** Ordered title candidates, with REACT_APP_ARCGIS_EXPANSION_LAYER_TITLE taking precedence. */
export function getExpansionSegmentsLayerTitles() {
  const override = (process.env.REACT_APP_ARCGIS_EXPANSION_LAYER_TITLE || "").trim();
  const overrides = override
    ? override
        .split(",")
        .map((t) => t.trim())
        .filter(Boolean)
    : [];
  const out = [];
  for (const title of [...overrides, ...EXPANSION_SEGMENTS_LAYER_TITLES]) {
    if (!out.some((t) => t.toLowerCase() === title.toLowerCase())) out.push(title);
  }
  return out;
}

export function getExpansionSegmentsFeatureLayerItemId() {
  return (
    (process.env.REACT_APP_ARCGIS_EXPANSION_FEATURE_LAYER_ID || "").trim() ||
    EXPANSION_SEGMENTS_FEATURE_LAYER_ITEM_ID
  );
}

export async function loadExpansionSegmentWebMap(apiKey) {
  const webmapId =
    (process.env.REACT_APP_ARCGIS_EXPANSION_WEBMAP_ID || "").trim() || EXPANSION_SEGMENT_WEBMAP_ID;
  return loadWebMapById(apiKey, webmapId);
}
